import { QuestionAndAnswer } from "./questionsAndAnswers";

export class DeleteBasicInformation {
  id: number;
  title: string;  
  questionsAndAnswers: QuestionAndAnswer[];
  createdUserId: number;
  isInfoSetDeleted: boolean;
}
